import * as Yup from "yup";

export const AddHolidaySchema = Yup.object().shape({
  name: Yup.string()
    .required("Holiday name is required")
    .min(3, "Holiday name is too Short!")
    .max(50, "Holiday name is too Long!"),
  date: Yup.date("Date is invalid").required("Date is required"),
});
